<template>
  <div>
    <v-row no-gutters justify="center" class="worldwideMask">
      <v-col cols="12" :md="8" :sm="7" class="mt-5">
        <div class="mr-md-3 wrapperBox">
          <Post
            :item="postDetail"
            @onData="onData"
            v-if="postDetail.type != POST_TYPE_REVIEW"
          />
          <Post
            v-else
            :item="postDetail"
            @onData="onData"
          >
            <PostRating :reviewData="postDetail.reviewData" readonly />
          </Post>
        </div>
        <v-container v-if="dataEmpty">
          <v-card class="postContent pa-5">
            <translate>The post is not longer available</translate>
          </v-card>
        </v-container>
      </v-col>
      <v-col cols="12" :md="4" :sm="5">
        <LatestReviewCard />
        <LatestVlogCard />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PostService from "@/services/PostService";
import Post from "@/components/Post/Post.vue";
import LatestReviewCard from "@/components/Card/LatestReviewCard";
import LatestVlogCard from "@/components/Card/LatestVlogCard";
import PostRating from "@/components/Post/PostRating";
export default {
  name: "PostDetail",
  components: { Post, LatestReviewCard, LatestVlogCard, PostRating },
  async created() {
    if (this.$route.params.id) {
      const filters = {
        filter_id: this.$route.params.id
      }
      if(this.$route.params.commentId) {
        filters['commentId'] = this.$route.params.commentId
      }
      const post = await PostService.getPostDetail(filters);
      console.log("post: ", post);
      if (post) {
        if (post.list.length !== 0) {
          this.postDetail = post.list[0];
        } else {
          this.dataEmpty = true
        }
      }
    }
  },
  data() {
    return {
      postDetail: {},
      dataEmpty: false
    };
  },
  computed: {
    courseDetail() {
      return this.$store.state.golfcourse.courseDetail;
    },
    isCourseAdmin() {
      let course = this.courseDetail || {};
      let courseRole = course.courseRole || [];
      if (courseRole.length) {
        let courseAdmin =
          courseRole.findIndex((r) => r === "Course Admin") !== -1;
        if (courseAdmin) return true;
      }
      return false;
    },
  },
  methods: {
    onData(item) {
      if (item.mode === "update") {
        delete item.mode;
        this.postDetail = { ...this.postDetail, ...item };
      }
      return;
    },
  },
};
</script>

